export default __webpack_public_path__ + "static/media/s8.bc0411a2.png";